namespace GeniuzPOS.ReportMasterData {
    export interface Report_1404Form {
    }

    export class Report_1404Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1404';
    }
}
